<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Cargos</h1>
    <button class="btn btn-primary" (click)="novoCargo()">Incluir Novo Cargo</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por descrição..." [(ngModel)]="searchTerm" (input)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Descrição</th>
          <th scope="col">Nível</th>
          <th scope="col">Salário Base</th>
          <th scope="col">Vale Alimentação</th>
          <th scope="col">Vale Refeição</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cargo of paginatedCargos">
          <th scope="row">{{ cargo.id }}</th>
          <td>{{ cargo.descricao }}</td>
          <td>{{ cargo.nivel }}</td>
          <td>{{ cargo.salarioBase | currency:'BRL' }}</td>
          <td>{{ cargo.valeAlimentacao | currency:'BRL'}}</td>
          <td>{{ cargo.valeRefeicao | currency:'BRL' }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm me-2" (click)="editarCargo(cargo.id)">Editar</button>
            <button type="button" class="btn btn-danger btn-sm" (click)="deleteCargo(cargo.id)">Excluir</button>
          </td>
        </tr>
        <tr *ngIf="paginatedCargos.length === 0">
          <td colspan="7" class="text-center text-muted py-4">Nenhum cargo encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(1)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages)">Última</a>
      </li>
    </ul>
  </nav>
</div>
